import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function Navbar() {
  const { user, signOut } = useAuth();
  const loc = useLocation();
  const tab = (path, label) => (
    <Link
      to={path}
      className={`px-3 py-1.5 text-sm rounded-md ${
        loc.pathname === path || (path !== '/' && loc.pathname.startsWith(path))
          ? 'bg-neutral-100 text-ink'
          : 'text-muted hover:bg-neutral-50'
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="border-b border-border bg-white sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2 font-medium text-ink">
            <img src="/favicon.png" alt="VF" className="h-8 w-8 object-contain" />
            AI Launchpad
          </Link>
          <nav className="flex gap-1">
            {tab('/', 'Apps')}
            {tab('/usage', 'Usage')}
            {user?.role === 'ADMIN' && tab('/settings/directory', 'Directory')}
            {user?.role === 'ADMIN' && tab('/settings/anthropic', 'Anthropic')}
          </nav>
        </div>
        <div className="flex items-center gap-3 text-sm">
          <span className="text-muted">{user?.email}</span>
          <button onClick={signOut} className="text-sm text-muted hover:text-ink">
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
